import {Component, OnDestroy} from '@angular/core';
import {ToasterModule, ToasterService, ToasterConfig} from 'angular2-toaster/angular2-toaster';
import {Router, ActivatedRoute, NavigationStart, NavigationEnd, NavigationError} from '@angular/router';
import {AuthenticationService} from './services/authentication.service';
import {Location} from '@angular/common';
import {Observable} from 'rxjs/Rx';
@Component({
    // tslint:disable-next-line
    selector: 'body',
    templateUrl: './app.component.html',
    providers: [AuthenticationService]
})
export class AppComponent {
    private toasterService: ToasterService;
    private navigationMenuID: number;
    navigationSubscription;
    isLogin: any;
    public toasterconfig: ToasterConfig =
    new ToasterConfig({
      tapToDismiss: true,
      timeout: 5000
    });

    constructor(toasterService: ToasterService, private router: Router, private location: Location,
                private route: ActivatedRoute, private authenticationService: AuthenticationService) {
        this.toasterService = toasterService;
        this.isLogin = Observable.interval(9000)
            .subscribe(x => {
                if (localStorage.getItem('access_token') || localStorage.getItem('refresh_token')) {
                    //this.checkUser();
                }

            });
        var that = this;
        /*this.router.routeReuseStrategy.shouldReuseRoute = function () {
         return false;
         };*/

        /*this.router.events.subscribe((evt) => {
         if (evt instanceof NavigationEnd) {
         // trick the Router into believing it's last link wasn't previously loaded
         //this.router.navigated = false;
         // if you need to scroll back to top, here is the right place
         //window.scrollTo(0, 0);
         }
         });*/

        this.router.events
            .filter(e => e.constructor.name === 'RoutesRecognized')
            .pairwise()
            .subscribe((e: any[]) => {
                var nextState = e[1].urlAfterRedirects;
                var pairwiseState = e[0].urlAfterRedirects;
                if (pairwiseState.indexOf('-edit') == -1 && nextState.indexOf('-edit') == -1) {
                    var keys = Object.keys(localStorage), i = keys.length;
                    while (i--) {
                        if (keys[i].indexOf('DataTables_') >= 0) {
                            localStorage.removeItem(keys[i]);
                        }
                    }

                    var keys2 = Object.keys(sessionStorage), z = keys2.length;
                    while (z--) {
                        if (keys2[z].indexOf('DataTables_') >= 0) {
                            sessionStorage.removeItem(keys2[z]);
                        }
                    }
                }
            });

        /*this.router.events.subscribe((event) => {
         if (event instanceof NavigationStart) {
         console.log('Router event start:', event);
         }

         if (event instanceof NavigationEnd) {
         console.log('Router event:', event);
         }
         if (event instanceof NavigationError) {
         }
         });*/

        /* router.events
         .filter(e => e instanceof NavigationEnd)
         .forEach(e => {
         this.navigationMenuID = this.route.children[0].children[0].data._value.id;
         this.checkUserGroupAccessRights();
         });*/
    }

    /*ngOnDestroy() {
     // avoid memory leaks here by cleaning up after ourselves. If we
     // don't then we will continue to run our initialiseInvites()
     // method on every navigationEnd event.
     if (this.navigationSubscription) {
     this.navigationSubscription.unsubscribe();
     }
     }*/

    refreshToken() {
        this.authenticationService.refreshToken()
            .subscribe(
                data => {
                },
                error => {
                    this.authenticationService.logout();
                });
    }

    checkUser() {
        this.authenticationService
            .checkAuth()
            .get()
            .subscribe(resp => {

            }, (error) => {
                if (localStorage.getItem('refresh_token')) {
                    this.refreshToken();
                } else {
                    this.authenticationService.logout();
                }
            });
    }

}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts